module.exports = __webpack_public_path__ + "static/media/1017720.4f83de13.png";